import { gql } from "@apollo/client";

const DELETE_BOT = gql`
  mutation DeleteBot($botId: String!) {
    deleteBot(botId: $botId) {
      success
      error
    }
  }
`;

export default DELETE_BOT;
